export async function loadRudderStack(writeKey: string, dataPlaneUrl: string) {
    if (!window.rudderanalytics) {
        window.rudderanalytics = await import("rudder-sdk-js");
        window.rudderanalytics.load(writeKey, dataPlaneUrl, {
            integrations: { All: true },
        });
        window.rudderanalytics.ready(() => {
            window.rudderanalytics.page();
        });
    }
}
